import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventFaq extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventFaq';

    // Define default properties here
    static instanceDefaults() {
        return {
            answer: '',
            answer_tc: '',
            answer_sc: '',
        }
    }
}

const servicePath = 'f-faq';
const servicePlugin = makeServicePlugin({
    Model: EventFaq,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin